export const COMPETITION_ID = "-Mqsr3_oLFSOAk_-sg7B";
